// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import articleStatusEntity from './entities/article-status.json';
import articleStatusMenu from '../pages/article-status/menu.json';
import articleStatusFullForm from '../pages/article-status/forms/full.json';
import articleStatusContextForm from '../pages/article-status/forms/context.json';
import articleStatusMiniForm from '../pages/article-status/forms/mini.json';
import articleStatusLookupForm from '../pages/article-status/forms/lookup.json';
import articleStatusTableView from '../pages/article-status/views/table.json';
import articleStatusDashboardView from '../pages/article-status/views/dashboard.json';

/** Тип запису «Статус статті» зі сторінками пакета: меню, форми та подання з pages/article-status/. */
export const articleStatusDefinition: IRecordTypeDefinition = {
  ...articleStatusEntity,
  views: assembleViewSet({
      table: articleStatusTableView,
      dashboard: articleStatusDashboardView,
  }),
  form: articleStatusFullForm,
  forms: { full: articleStatusFullForm, context: articleStatusContextForm, mini: articleStatusMiniForm, lookup: articleStatusLookupForm },
  menu: articleStatusMenu,
} as IRecordTypeDefinition;
